/* eslint-disable */
export default {
  cancel: 'キャンセル',
  reply: '返信',
  onMyWay: '移動中です',
  customMessage: 'カスタムメッセージ',
  callMeBackIn: '折り返しお電話ください',
  willCallYouBackIn: '折り返しお電話します',
  min: '分',
  hours: '時間',
  days: '日',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
